import { render, staticRenderFns } from "./practiceNorms.vue?vue&type=template&id=2951bf2e&scoped=true&"
import script from "./practiceNorms.vue?vue&type=script&lang=js&"
export * from "./practiceNorms.vue?vue&type=script&lang=js&"
import style0 from "./practiceNorms.vue?vue&type=style&index=0&id=2951bf2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2951bf2e",
  null
  
)

export default component.exports